import * as React from 'react';
import { TextField, IconButton, InputLabel, FormHelperText } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/en-au';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

export const Time = ({ id, value, updateValue, path, description, errors, visible, label }) => {
  // console.log('value', value)
  const [dateValue, setDateValue] = React.useState(value ? dayjs(value, 'hh:mm a') : null);

  const handleChange = (value) => {
    setDateValue(value)
    updateValue(value.format('hh:mm a'));
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-au">
        <TimePicker
          label={label}
          value={dateValue}
          onChange={handleChange}
          slotProps={{ textField: { fullWidth: true } }}
          format="hh:mm a"
          timeSteps={{ hours: 1, minutes: 1 }}
        />
      </LocalizationProvider>
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
